<template>
  <main id="app">
    <iso-gallery/>
  </main>
</template>

<script>
  import IsoGallery from '@/components/IsoGallery';

  export default {
    name: 'app',
    components: {
      IsoGallery,
    },
  };
</script>



// WEBPACK FOOTER //
// src/App.vue